import './App.css';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages';
import BlogPostPage from './pages/blogpost';
import computational from './pages/computational';
import TermsOfService from './pages/termsofservice';
import PrivacyPolicy from './pages/privacypolicy';
import ContactUs from './pages/contactus';
import Sizing_guidelines from './pages/sizing_guidelines';
import Chat from './pages/colab_lic';
import Aboutus from './pages/aboutus';
import LearnMorePage from './pages/learnmore';
import SciencePage from './pages/science';
import PdfViewerPage from './pages/pdfviewer';
import React from 'react';
import SEO from './components/SEO';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <>
      <SEO />
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/blogpost" component={BlogPostPage} exact />
          <Route path="/computational" component={computational} exact />
          <Route path="/terms-of-service" component={TermsOfService} exact />
          <Route path="/privacy-policy" component={PrivacyPolicy} exact />
          <Route path="/sizing_guidelines" component={Sizing_guidelines} exact />
          <Route path="/contact-us" component={ContactUs} exact />
          <Route path="/chat-with-us" component={Chat} exact />
          <Route path="/about-pacified" component={Aboutus} exact />
          <Route path="/learn-more" component={LearnMorePage} exact />
          <Route path="/science" component={SciencePage} exact />
          <Route path="/pdf-viewer" component={PdfViewerPage} exact />
        </Switch>
      </Router>
    </>
  );
}

export default App;
